import type { Environment } from "./Environment"

export function getPcw20Domain(entryDN: string, env: Environment | null): string | undefined {
	const domain = pcw20Domains[entryDN]
	if (!domain) {
		return undefined
	}
	if (env === "prod") {
		return domain
	}
	if (env === "preview") {
		const subdomain = domain.split(".")[0]
		return `${subdomain}.platform.dealerwebsites-dev.pdcp.porsche-preview.digital`
	}
	// dev is not needed as PCW only has prod and preview - listing ids from dev would lead to 404
	return undefined
}

const pcw20Domains: Record<string, `${string}.porsche.${string}`> = {
	"10006": "maienfeld.porsche.ch",
	"10010": "rennes.porsche.fr",
	"10039": "giessen.porsche.de",
	"10055": "sydneysouth.porsche.com.au",
	"10163": "clermont-ferrand.porsche.fr",
	"10340": "beachwood.porsche.com",
	"10365": "zell-am-see.porsche.at",
	"10382": "bonn.porsche.de",
	"10457": "manhattanmotorcars.porsche.com",
	"10598": "saskatchewan.porsche.ca",
	"10614": "coloradosprings.porsche.com",
	"10681": "goeppingen.porsche.de",
	"10738": "lugano.porsche.ch",
	"1078": "lorraine.porsche.fr",
	"10787": "moers.porsche.de",
	"1088": "virginiabeach.porsche.com",
	"10917": "bamberg.porsche.de",
	"10926": "okemos.porsche.com",
	"10938": "mcdaniels.porsche.com",
	"11058": "nashville.porsche.com",
	"1107": "bastia.porsche.fr",
	"11205": "carlsbad.porsche.com",
	"11278": "nantes.porsche.fr",
	"11327": "valley-imports.porsche.com",
	"11328": "kassel.porsche.de",
	"11364": "southpoint.porsche.com",
	"11398": "westpalmbeach.porsche.com",
	"1143": "altoetting.porsche.de",
	"11558": "niederbayern.porsche.de",
	"11639": "hartford.porsche.com",
	"11714": "soest.porsche.de",
	"11731": "reutlingen.porsche.de",
	"11820": "torreon.porsche.mx",
	"11822": "autobahn.porsche.com",
	"12058": "palmsprings.porsche.com",
	"12158": "tulsa.porsche.com",
	"12192": "winnipeg.porsche.ca",
	"12215": "owingsmills.porsche.com",
	"12265": "darmstadt.porsche.de",
	"1227": "paderborn.porsche.de",
	"12280": "atlantaperimeter.porsche.com",
	"12405": "goettingen.porsche.de",
	"12409": "montpellier.porsche.fr",
	"12518": "augsburg.porsche.de",
	"12559": "rosenheim.porsche.de",
	"12656": "waukesha.porsche.com",
	"1269": "hofheim.porsche.de",
	"12716": "stuttgart.porsche.de",
	"12811": "wien-liesing.porsche.at",
	"12843": "recklinghausen.porsche.de",
	"12902": "trier.porsche.de",
	"1297": "monterrey.porsche.mx",
	"12989": "winterthur.porsche.ch",
	"13029": "bethesda.porsche.com",
	"13072": "main-line.porsche.com",
	"13229": "hannover.porsche.de",
	"13249": "allgaeu.porsche.de",
	"13301": "ulm.porsche.de",
	"13319": "kaernten.porsche.at",
	"13333": "mannheim.porsche.de",
	"1334": "westhouston.porsche.com",
	"13412": "fairfield.porsche.com",
	"13432": "rockford.porsche.com",
	"13529": "cincinnatikings.porsche.com",
	"13610": "sanantonio.porsche.com",
	"13612": "gstaad.porsche.ch",
	"13614": "leon.porsche.mx",
	"13641": "annapolis.porsche.com",
	"13731": "victoria.porsche.ca",
	"13787": "theexchange.porsche.com",
	"13841": "strasbourg.porsche.fr",
	"13894": "spokane.porsche.com",
	"1398": "buffalo.porsche.com",
	"13987": "suncoast.porsche.com",
	"14020": "hamburg-nordwest.porsche.de",
	"14248": "nashua.porsche.com",
	"14371": "oberoesterreich.porsche.at",
	"14430": "muenchen.porsche.de",
	"14453": "berlin.porsche.de",
	"14529": "ocala.porsche.com",
	"14568": "tours.porsche.fr",
	"14597": "baden-baden.porsche.de",
	"14642": "isringhausen.porsche.com",
	"14975": "whiteallen.porsche.com",
	"1500000031": "boise.porsche.com",
	"1500000036": "bayonne.porsche.fr",
	"15000000789": "lausanne.porsche.ch",
	"15000000790": "geneve.porsche.ch",
	"1500000098": "asheville.porsche.com",
	"15000001010": "tijuana.porsche.mx",
	"15000001037": "louisville.porsche.com",
	"15000001088": "canberra.porsche.com.au",
	"15000001275": "arlington.porsche.com",
	"1500000129": "reims.porsche.fr",
	"15000001337": "minden.porsche.de",
	"15000001338": "leer.porsche.de",
	"15000001339": "emsbueren.porsche.de",
	"15000001484": "luzern.porsche.ch",
	"15000001544": "livermore.porsche.com",
	"15000001562": "dublin.porsche.com",
	"15000002382": "greenville.porsche.com",
	"15000002545": "desmoines.porsche.com",
	"15000002911": "sankt-poelten.porsche.at",
	"15000003050": "omaha.porsche.com",
	"15000003162": "fremont.porsche.com",
	"15000003289": "annarbor.porsche.com",
	"15000003947": "waiblingen-approved.porsche.de",
	"15000004086": "atlantanorthwest.porsche.com",
	"15000004109": "adelaide.porsche.com.au",
	"15000004158": "atlantanorth.porsche.com",
	"1500000675": "chantilly.porsche.com",
	"1500000702": "west-island.porsche.ca",
	"1500000746": "vorarlberg.porsche.at",
	"1500001157": "detroitnorth.porsche.com",
	"1500001266": "newcastle.porsche.com.au",
	"1500001406": "dresden.porsche.de",
	"1500001453": "hiltonhead.porsche.com",
	"1500001454": "conshohocken.porsche.com",
	"1500002043": "markham.porsche.ca",
	"1500002079": "vaughan.porsche.ca",
	"1500002162": "huntvalley.porsche.com",
	"1500002163": "westwood.porsche.com",
	"1500002164": "littleton.porsche.com",
	"1500002445": "southaustin.porsche.com",
	"1500002471": "dornbirn.porsche.at",
	"1500002659": "leipzig.porsche.de",
	"1500002769": "hobart.porsche.com.au",
	"1500002996": "dinslaken.porsche.de",
	"1500003030": "london.porsche.ca",
	"1500003143": "quebec.porsche.ca",
	"1500003415": "zuerich-studio.porsche.ch",
	"1500003446": "lueneburg.porsche.de",
	"1500003495": "sanluisobispo.porsche.com",
	"1500003534": "basel.porsche.ch",
	"1500003676": "mobile.porsche.com",
	"1500003778": "caen.porsche.fr",
	"1500003779": "rouen.porsche.fr",
	"1500003786": "asker-baerum.porsche.no",
	"1500003787": "bergen.porsche.no",
	"1500003788": "oslo.porsche.no",
	"1500003789": "gardermoen.porsche.no",
	"1500003791": "porsgrunn.porsche.no",
	"1500003792": "trondheim.porsche.no",
	"1500003793": "alesund.porsche.no",
	"1500003795": "kristiansand.porsche.no",
	"1500003798": "stavanger.porsche.no",
	"1500003799": "tromso.porsche.no",
	"1500004075": "danbury.porsche.com",
	"1500004298": "kiel.porsche.de",
	"1500004629": "paris-levallois.porsche.fr",
	"1500004680": "paris-velizy.porsche.fr",
	"1500004681": "paris-16.porsche.fr",
	"1500004682": "paris-saint-maur.porsche.fr",
	"1500004683": "paris-est.porsche.fr",
	"1500004722": "barrington.porsche.com",
	"1500004759": "kitchener-waterloo.porsche.ca",
	"1500005356": "sanfrancisco.porsche.com",
	"1500005873": "wilmington.porsche.com",
	"1500005958": "frankfurt-west-approved.porsche.de",
	"1500006110": "ingolstadt.porsche.de",
	"1500006111": "friedrichshafen.porsche.de",
	"1500006153": "servicecentereasthanover.porsche.com",
	"1500006200": "townsville.porsche.com.au",
	"1500006795": "minneapolis.porsche.com",
	"1500006915": "stpaul.porsche.com",
	"1500007111": "cary.porsche.com",
	"1500007136": "neworleans.porsche.com",
	"1500007334": "sacramento.porsche.com",
	"1500007350": "lopez-mateos.porsche.mx",
	"1500007374": "shreveport.porsche.com",
	"1500007377": "fortcollins.porsche.com",
	"1500007381": "atlantanortheast.porsche.com",
	"1500007383": "cancun.porsche.mx",
	"1500007385": "merida.porsche.mx",
	"1500007654": "doncaster.porsche.com.au",
	"1500007666": "brighton.porsche.com.au",
	"1500007761": "servicecenterchesterfield.porsche.com",
	"1500007863": "hamburg-nordost-approved.porsche.de",
	"1500008083": "fredrikstad.porsche.no",
	"1500008248": "henderson.porsche.com",
	"1500008509": "melbourne.porsche.com.au",
	"1500008598": "lille.porsche.fr",
	"1500008620": "lyon.porsche.fr",
	"1500008621": "montelimar.porsche.fr",
	"1500008713": "sewickley.porsche.com",
	"1500008760": "son.porsche.no",
	"1500008884": "villingen.porsche.de",
	"1500009137": "amberg.porsche.de",
	"1500009226": "kassel-classic.porsche.de",
	"1500009232": "la-roma.porsche.mx",
	"1500009507": "burlington.porsche.com",
	"1500009561": "boston.porsche.com",
	"1500009672": "sylt-studio.porsche.de",
	"1500009691": "nanaimo.porsche.ca",
	"1500009692": "arrowhead.porsche.com",
	"15030": "offenburg.porsche.de",
	"1506": "aachen.porsche.de",
	"15073": "landshut.porsche.de",
	"15164": "birmingham.porsche.com",
	"1521": "rocklin.porsche.com",
	"15258": "interlomas.porsche.mx",
	"15519": "southampton.porsche.com",
	"15542": "saarland.porsche.de",
	"15660": "zuerich.porsche.ch",
	"15711": "perth.porsche.com.au",
	"15713": "essen.porsche.de",
	"15862": "thecollection.porsche.com",
	"15895": "koblenz.porsche.de",
	"15938": "pfaffenhausen-service.porsche.de",
	"1605": "la-rochelle.porsche.fr",
	"1606": "vancouver.porsche.ca",
	"16089": "aargau.porsche.ch",
	"16172": "bielefeld.porsche.de",
	"16252": "beaverton.porsche.com",
	"16352": "antibes.porsche.fr",
	"16358": "parramatta.porsche.com.au",
	"1644": "frejus.porsche.fr",
	"16457": "bern.porsche.ch",
	"16570": "stlouis.porsche.com",
	"16808": "wiesbaden.porsche.de",
	"16811": "veracruz.porsche.mx",
	"16824": "locarno.porsche.ch",
	"16852": "chandler.porsche.com",
	"16878": "westbroward.porsche.com",
	"16880": "brest.porsche.fr",
	"1689": "fulda.porsche.de",
	"16927": "monmouth.porsche.com",
	"16968": "austin.porsche.com",
	"16979": "oberer-zuerichsee.porsche.ch",
	"17011": "jacksonville.porsche.com",
	"17012": "milwaukeenorth.porsche.com",
	"17037": "boeblingen.porsche.de",
	"17038": "stuttgart-flughafen.porsche.de",
	"17112": "warrington.porsche.com",
	"17151": "bayreuth.porsche.de",
	"1729": "polanco.porsche.mx",
	"17392": "wichita.porsche.com",
	"1742": "toulon.porsche.fr",
	"17485": "north-toronto.porsche.ca",
	"175": "zug.porsche.ch",
	"17605": "berlin-adlershof.porsche.de",
	"17640": "landau.porsche.de",
	"17777": "kelowna.porsche.ca",
	"17825": "loerrach.porsche.de",
	"17826": "freiburg.porsche.de",
	"17939": "downtownla.porsche.com",
	"18006": "rive-sud.porsche.ca",
	"18054": "irvine.porsche.com",
	"1826": "lehi.porsche.com",
	"18361": "santa-fe.porsche.mx",
	"18371": "grapevine.porsche.com",
	"18436": "lehighvalley.porsche.com",
	"18444": "olympiapark.porsche.de",
	"18445": "muenchen-sued.porsche.de",
	"18471": "queretaro.porsche.mx",
	"18477": "meuspath-service.porsche.de",
	"18520": "bakersfield.porsche.com",
	"18525": "woodlandhills.porsche.com",
	"18650": "poitiers.porsche.fr",
	"18657": "jackson.porsche.com",
	"18712": "limoges.porsche.fr",
	"18862": "mechanicsburg.porsche.com",
	"18984": "hawaii.porsche.com",
	"18992": "northolmsted.porsche.com",
	"18993": "pittsburgh.porsche.com",
	"1915": "lincolnwood.porsche.com",
	"19151": "richmond.porsche.ca",
	"19499": "marin.porsche.com",
	"1973": "annecy.porsche.fr",
	"19748": "dallas.porsche.com",
	"20026": "saltlakecity.porsche.com",
	"2122": "plano.porsche.com",
	"2148": "paris-ouest.porsche.fr",
	"2296": "clearwater.porsche.com",
	"2442": "pforzheim.porsche.de",
	"248": "lorient.porsche.fr",
	"2507": "grenoble.porsche.fr",
	"2534": "steiermark.porsche.at",
	"2551": "newportbeach.porsche.com",
	"2744": "mainz.porsche.de",
	"2827": "wuppertal.porsche.de",
	"2911": "halifax.porsche.ca",
	"2975": "bad-homburg.porsche.de",
	"298": "jackingrammotors.porsche.com",
	"3023": "bellevue.porsche.com",
	"3045": "amagfirst.porsche.ch",
	"3061": "calgary.porsche.ca",
	"3073": "luebeck.porsche.de",
	"3124": "arpajon.porsche.fr",
	"315": "duesseldorf.porsche.de",
	"3234": "englewood.porsche.com",
	"326": "warwick.porsche.com",
	"3286": "regensburg.porsche.de",
	"3290": "westlake.porsche.com",
	"3413": "huntsville.porsche.com",
	"3577": "columbus.porsche.com",
	"3654": "charlottesville.porsche.com",
	"366": "prestige.porsche.ca",
	"3719": "orleans.porsche.fr",
	"3748": "burlingame.porsche.com",
	"3855": "bremen.porsche.de",
	"3964": "magdeburg.porsche.de",
	"4012": "sierre.porsche.ch",
	"4159": "san-angel.porsche.mx",
	"4239": "braunschweig.porsche.de",
	"4309": "dijon.porsche.fr",
	"4374": "perpignan.porsche.fr",
	"4375": "nuernberg-suedwest-service.porsche.de",
	"439": "bensberg.porsche.de",
	"4424": "orlando.porsche.com",
	"4491": "nuernberg.porsche.de",
	"4612": "syracuse.porsche.com",
	"4765": "wuerzburg.porsche.de",
	"4798": "thevillage.porsche.com",
	"4881": "hamburg.porsche.de",
	"4950": "willich.porsche.de",
	"4983": "tysonscorner.porsche.com",
	"5008": "hegau-bodensee.porsche.de",
	"5025": "downtown-toronto.porsche.ca",
	"5026": "roissy.porsche.fr",
	"5036": "st-gallen.porsche.ch",
	"5100": "puebla.porsche.mx",
	"5134": "neuchatel.porsche.ch",
	"5150": "wiener-neustadt.porsche.at",
	"5166": "heilbronn.porsche.de",
	"5192": "lauzon.porsche.ca",
	"5249": "oldenburg.porsche.de",
	"5263": "goldcoast.porsche.com",
	"5296": "jackdaniels.porsche.com",
	"5381": "foxvalley.porsche.com",
	"5399": "siegen.porsche.de",
	"5404": "mckenna.porsche.com",
	"5437": "edmonton.porsche.ca",
	"5478": "stevenscreek.porsche.com",
	"553": "marseille.porsche.fr",
	"5574": "markmotors.porsche.ca",
	"5739": "waldshut-tiengen-service.porsche.de",
	"5890": "hendrick.porsche.com",
	"5940": "tirol.porsche.at",
	"5946": "erfurt.porsche.de",
	"5968": "tucson.porsche.com",
	"6027": "richmond.porsche.com",
	"6056": "saint-etienne.porsche.fr",
	"6099": "kaiserslautern.porsche.de",
	"6161": "lasvegas.porsche.com",
	"6174": "amityville.porsche.com",
	"6237": "muenster.porsche.de",
	"6268": "paulmiller.porsche.com",
	"6292": "solingen.porsche.de",
	"6316": "grandrapids.porsche.com",
	"6390": "bordeaux.porsche.fr",
	"650": "toulouse.porsche.fr",
	"6536": "latham.porsche.com",
	"6540": "northscottsdale.porsche.com",
	"6561": "limburg.porsche.de",
	"6638": "tomwood.porsche.com",
	"6658": "goldcoast.porsche.com.au",
	"666": "reno.porsche.com",
	"6666": "silverspring.porsche.com",
	"6688": "willoughby.porsche.com.au",
	"7104": "riveroaks.porsche.com",
	"7340": "5seen.porsche.de",
	"7630": "madison.porsche.com",
	"7772": "whiteplains.porsche.com",
	"8054": "chattanooga.porsche.com",
	"8066": "berlin-potsdam.porsche.de",
	"8099": "avignon.porsche.fr",
	"8142": "harper.porsche.com",
	"8160": "karlsruhe.porsche.de",
	"8237": "kansascity.porsche.com",
	"8248": "charleston.porsche.com",
	"8398": "salzburg.porsche.at",
	"8412": "stratham.porsche.com",
	"8414": "garmisch.porsche.de",
	"8441": "gossett.porsche.com",
	"845": "harris.porsche.com",
	"8575": "mulhouse.porsche.fr",
	"8580": "denverwest.porsche.com",
	"8601": "koeln.porsche.de",
	"8659": "chemnitz.porsche.de",
	"8703": "langley.porsche.ca",
	"8735": "rostock.porsche.de",
	"8828": "rochester.porsche.com",
	"8841": "redwoodcity.porsche.com",
	"8893": "edison.porsche.com",
	"8899": "oakville.porsche.ca",
	"8910": "wien-nord.porsche.at",
	"9012": "southbay.porsche.com",
	"9064": "schwaebisch-gmuend.porsche.de",
	"9211": "bend.porsche.com",
	"9376": "oklahomacity.porsche.com",
	"939": "dortmund.porsche.de",
	"9409": "bronschhofen.porsche.ch",
	"9411": "frankfurt.porsche.de",
	"9459": "guadalajara.porsche.mx",
	"958": "albuquerque.porsche.com",
	"9602": "osnabrueck.porsche.de",
	"963": "monaco.porsche.fr",
	"9692": "brisbane.porsche.com.au",
	"9817": "greenwich.porsche.com",
	"985": "hagen.porsche.de",
	//"1500001150": "downtownchicago.porsche.com",
	//"13652": "monterey.porsche.com",
	//"11565": "westmont.porsche.com",
	// "11822": "autobahn.porsche.com",
	// "13846": "champion.porsche.com",
	// "6206": "destin.porsche.com",
	// "9351": "dpatrick.porsche.com",
	// "15206": "fortmyers.porsche.com",
	// "1826": "lehi.porsche.com",
	// "1500007384": "littlerock.porsche.com",
	// "2125": "melbourne.porsche.com",
	// "7367": "naples.porsche.com",
	// "1388": "northhouston.porsche.com",
	// "20009": "ontario.porsche.com",
	// "13553": "orlandpark.porsche.com",
	// "833": "riverside.porsche.com",
	// "18374": "southorlando.porsche.com",
	// "1500005974": "sugarland.porsche.com",
	// "10317": "tallahassee.porsche.com",
	// "1500002156": "tampa.porsche.com",
	// "18051": "wyomingvalley.porsche.com",
}
